<template>
  <Container type="card-full">
    <div slot="header">
      <el-button  @click="addDsfield">新增</el-button>
      <el-button  @click="delDsfield">删除</el-button>
      <el-button  @click="sortDsfield">重新排序</el-button>
      <el-button  @click="close">关闭</el-button>
    </div>
    <div class="container">
      <vggrid ref="xGrid" class="vggrid" :list="list" tableheight="700" flexname=""
              :cols="cols"
              :showfooter="false"
              :showPage="false" :resizable="true"
              @cellClick="cellClick"></vggrid>
      <el-form :model="form" ref="form"  class="content ss-fl" v-if="dsfieldform">
        <el-row>
          <el-col :span="5">
            <el-form-item label="序号" :label-width="formLabelWidth">
              <el-input v-model="form.dsfieldseq" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="列名" :label-width="formLabelWidth">
              <el-input v-model="form.dsfieldcode" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="列说明" :label-width="formLabelWidth">
              <el-input v-model="form.dsfieldname" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form>
              <el-row>
                <el-col :span="7">
                  <el-form-item label="字段宽度" :label-width="formLabelWidth">
                    <el-select v-model="form.dsfieldtype" :clearable="true" @change="changeType">
                      <el-option v-for="(item, index) in fieldtypeList" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col  :span="7">
                  <el-form-item label="字段宽度" :label-width="formLabelWidth">
                    <el-input v-model="form.dsfieldwid" auto-complete="off" >宽度</el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="字段小数位" :label-width="formLabelWidth">
                    <el-input v-model="form.dsfielddig" auto-complete="off" >小数位</el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="数据源表" :label-width="formLabelWidth">
              <el-select v-model="form.dsfielddstableid" :clearable="true">
                <el-option v-for="(item, index) in dstableList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="字段表达式" :label-width="formLabelWidth">
              <el-input v-model="form.dsfieldexpr" :maxlength="255" type="textarea"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="条件类型" :label-width="formLabelWidth">
              <el-select v-model="form.dsfieldfiltertype" :clearable="true">
                <el-option v-for="(item, index) in dsfieldfiltertypeList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
              <el-checkbox v-model="form.dsfieldishide">隐藏列</el-checkbox>
              <el-checkbox v-model="form.dsfieldissum">合计列</el-checkbox>
              <el-checkbox v-model="form.dsfieldhide">分组列</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="查询条件控件类型" :label-width="formLabelWidth">
              <el-select v-model="form.dsfieldeditflg" :clearable="true">
                <el-option v-for="(item, index) in dsfieldeditflgList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item label="查询助手" :label-width="formLabelWidth">
              <el-select v-model="form.dsfieldbrows" :clearable="true" >
                <el-option v-for="(item, index) in dsfieldbrowsList" :label="item.label" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label="返回字段" :label-width="formLabelWidth">
              <el-input v-model="form.dsfieldbrowsreturn" auto-complete="off" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="" :label-width="formLabelWidth">
          <el-button type="primary" @click="saveDsfield">保存</el-button>
          <el-button type="danger" @click="delDsfield">删除</el-button>
        </el-form-item>
      </el-form>
    </div>
  </Container>
</template>
<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import vggrid from '../common/vggrid'
  export default {
    name: 'dsfieldForm',
    data () {
      return {
        list: [],
        dsfieldform: false,
        fieldtypeList:[],
        dsfieldeditflgList: [],
        dsfieldbrowsList: [],
        dsfieldfiltertypeList: [],
        dstableList: [],
        ds: this.$route.params.form,
        cols: [
          { field: 'dsfieldseq', title: '序号',calculExpr:'', addNewRowFlg: false},
          { field: 'dsfieldcode', title: '列名',calculExpr:'',addNewRowFlg: false},
          { field: 'dsfieldname', title: '列说明',calculExpr:'',addNewRowFlg: false},
        ],
        form: {},
        loading: true,
        formLabelWidth: '130px'
      }
    },
    created () {
    },
    activated() {
      this.init()
      this.getDsfieldList()
      this.getFieldtypeList()
      this.getDsfieldeditflgList()
      this.getDsfieldbrowsList()
      this.getDsfieldfiltertypeList()
      this.getDstableList()
    },
    mounted () {
    },
    components: {vggrid},
    methods: {
      async init(){
        this.list = []
        this.dsfieldform = false
        this.fieldtypeList = []
        this.dsfieldeditflgList = []
        this.dsfieldbrowsList = []
        this.dsfieldfiltertypeList = []
        this.dstableList = []
        this.ds = this.$route.params.form
        this.form = {}
      },
      async addDsfield () {
        this.dsfieldform = true
        let maxSeq = 0
        this.list.forEach(item => {
          if (item.dsfieldseq>maxSeq) {
            maxSeq = item.dsfieldseq
          }
        })
        maxSeq += 10
        this.form = {
          dsfieldid: 0,
          dsfieldseq: maxSeq,
          dsfieldcode: '',
          dsfieldname: '',
          dsfieldtype: '',
          dsfieldwid: '',
          dsfielddig: '',
          dsfieldexpr: '',
          dsfieldishide: '',
          dsfieldissum: '',
          dsfieldisgroup: '',
          dsfieldfiltertype: '',
          dsfieldeditflg: '',
          dsfieldbrows: '',
          dsfieldreturncode: ''
        }
      },
      async getFieldtypeList() {
        this.fieldtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'fieldtype'}
        })
      },
      async getDstableList() {
        this.dstableList = await request({
          url: '/xtgl/ds/getDstableListByDsid',
          method: "get",
          params: {dsid: this.ds.dsid}
        })
      },
      async getDsfieldeditflgList() {
        this.dsfieldeditflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'dsfieldeditflg'}
        })
      },
      async getDsfieldbrowsList() {
        this.dsfieldbrowsList = await request({
          url: '/kfgl/brows/getBrowsList',
          method: "get",
          params: {comid: 1}
        })
      },
      async getDsfieldfiltertypeList() {
        this.dsfieldfiltertypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'dsfieldfiltertype'}
        })
      },
      async changeType() {
        switch (this.form.dsfieldtype) {
          case 'C':
            this.form.dsfieldwid = 20
            this.form.dsfielddig =0
          case 'L':
            this.form.dsfieldwid = 10
            this.form.dsfielddig =0
          case 'N':
            this.form.dsfieldwid = 5
            this.form.dsfielddig =0
          case 'B':
            this.form.dsfieldwid = 3
            this.form.dsfielddig =0
          case 'F':
            this.form.dsfieldwid = 12
            this.form.dsfielddig =2
          case 'D':
            this.form.dsfieldwid = 0
            this.form.dsfielddig =0
          case 'T':
            this.form.dsfieldwid = 0
            this.form.dsfielddig =0
        }
      },
      async sortDsfield () {
        let data = await request({
          url: '/xtgl/ds/sortDsfield',
          method: "post",
          data: this.list
        })
        if (data.issuccess === 1) {
          this.getDsfieldList()
          this.$message.success('排序成功！')
        } else {
          this.$message.error('排序失败！')
        }


      },
      async delDsfield () {
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/xtgl/ds/delDsfield',
            method: "post",
            data: this.form
          })
          if (data.issuccess === 1) {
            this.getDsfieldList()
            this.$message.success('删除成功！')
          }
        })
      },
      async saveDsfield () {
        this.form.dsfielddsid = this.ds.dsid
        await request({
          url: '/xtgl/ds/saveDsfield',
          method: "post",
          data: this.form
        })
        this.$message.success('操作成功')
        await this.getDsfieldList()
        this.dsfieldform = false
      },
      async cellClick (row) {
        this.form = row.row
        if (this.form.dsfieldissum === '1') {
          this.form.dsfieldissum = true
        }
        if (this.form.dsfieldishide === '1') {
          this.form.dsfieldishide = true
        }
        this.dsfieldform = true
      },
      async pagechange (fcPage) {
        this.query.currPage = fcPage.currentPage
        this.query.pageSize = fcPage.pageSize
        this.getDsfieldList()
      },
      async getDsfieldList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xtgl/ds/getDsfieldListByDsid',
          params: {dsid: this.ds.dsid}
        })
        this.list = res
        this.loading = false
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'dsIndex'})

      }
    },
    filters: {
    }
  }
</script>

<style lang="scss" scoped>
  .container {
    display: flex;
    .vggrid {
      border: 1px solid #d1dbe5;
      width: 400px;
      margin-right: 5px;
    }
    .content {
      width: 100%;
      padding-top: 10px;
      padding-right: 10px;
      border: 1px solid #d1dbe5;
    }
  }
  #menuReportDiv {
    height: 380px;
    overflow: auto;
  }
</style>
